/* eslint-disable class-methods-use-this */
import Flickity from 'flickity-imagesloaded';
import Base from '@studiometa/js-toolkit';
import useResize from '@studiometa/js-toolkit/services/resize';
import { isDev } from '../../config';
import PageProductSliderModal from './PageProductSliderModal';

const { props } = useResize();

/**
 * PageProductSlider class.
 */
export default class PageProductSlider extends Base {
  static config = {
    log: isDev(),
    name: 'PageProductSlider',
    refs: [
      'sliderCover',
      'sliderDots',
      'sliderArrowPrevious',
      'sliderArrowNext',
      'sliderDot[]',
      'sliderModal',
    ],
    components: {
      PageProductSliderModal,
    },
  };

  /**
   * isMobile
   */
  static get isMobile() {
    return !['s', 'm', 'l', 'xl', 'xxl'].includes(props().breakpoint);
  }

  sliderCover = null;

  sliderDots = null;

  /**
   * Mounted.
   *
   * @return {void}
   */
  mounted() {
    this.initSliders();
  }

  /**
   * resized
   */
  resized() {
    this.initSliders();
  }

  /**
   * Destroyed
   */
  destroyed() {
    this.$el.classList.add('opacity-10');

    if (this.sliderCover) {
      this.$refs.sliderCover.classList.remove('is-flickity-ready');
      this.sliderCover.destroy();
      this.sliderCover = null;
    }

    if (this.sliderDots) {
      this.$refs.sliderDots.classList.remove('is-flickity-ready');
      this.sliderDots.destroy();
      this.sliderDots = null;
    }

    this.$refs.sliderModal.$destroy();
  }

  /**
   * initSliders
   */
  initSliders() {
    const $this = this;

    if (!this.$refs.sliderCover) {
      return;
    }

    this.sliderCover = new Flickity(this.$refs.sliderCover, {
      cellAlign: 'left',
      draggable: false,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      on: {
        ready() {
          $this.$el.classList.remove('opacity-10');
          $this.$refs.sliderCover.classList.add('is-flickity-ready');
        },
        change() {
          $this.$refs.sliderDot.forEach(($dot, indexDot) => {
            if (indexDot === this.selectedIndex) {
              $dot.classList.add('is-active');
            } else {
              $dot.classList.remove('is-active');
            }
          });
        },
        staticClick(event, pointer, cellElement, cellIndex) {
          if ($this.$refs.sliderModal && $this.$refs.sliderModal.slider) {
            $this.$refs.sliderModal.slider.select(cellIndex, false, true);
            $this.$refs.sliderModal.open();
          }
        },
      },
    });

    if (!PageProductSlider.isMobile && !this.sliderDots && this.$refs.sliderDots) {
      this.sliderDots = new Flickity(this.$refs.sliderDots, {
        contain: true,
        draggable: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        on: {
          ready() {
            $this.$el.classList.remove('opacity-10');
            $this.$refs.sliderDots.classList.add('is-flickity-ready');
          },
          change(cellIndex) {
            $this.sliderCover.select(cellIndex);
          },
          staticClick(event, pointer, cellElement, cellIndex) {
            $this.sliderDots.select(cellIndex);
          },
        },
      });
    } else if (PageProductSlider.isMobile && this.sliderDots) {
      this.$refs.sliderDots.classList.remove('is-flickity-ready');
      this.sliderDots.destroy();
      this.sliderDots = null;
    }

    if (this.$refs.sliderModal) {
      this.$refs.sliderModal.$on('close', this.handleModalClose);
    }
  }

  /**
   * handleModalClose
   */
  handleModalClose() {
    this.sliderCover.select(this.$refs.sliderModal.slider.selectedIndex, false, true);
  }

  /**
   * onSliderArrowPreviousClick
   */
  onSliderArrowPreviousClick() {
    if (!PageProductSlider.isMobile) {
      this.sliderDots.previous();
    } else {
      this.sliderCover.previous();
    }
  }

  /**
   * onSliderArrowNextClick
   */
  onSliderArrowNextClick() {
    if (!PageProductSlider.isMobile) {
      this.sliderDots.next();
    } else {
      this.sliderCover.next();
    }
  }

  /**
   * onDotsClick
   */
  onSliderDotClick(event, index) {
    if (!PageProductSlider.isMobile) {
      return;
    }

    this.sliderCover.select(index);
  }
}
